// @view/panels/authentication/PasswordResetLogo.panel.tsx
import React from "react";
import EmptyView from "@view/EmptyView";
import type { VisibilityPhase } from "@ps-bridge/models/ui/visibilityPhase";
import PasswordResetLogoView from "@view/authentication/PasswordResetLogo.view";

type PasswordResetLogoPanelProps = {
  phase: VisibilityPhase;
  logoUri: string;
};

const PasswordResetLogoPanel: React.FC<PasswordResetLogoPanelProps> = ({ phase, logoUri }) => {
  const phaseKeys = {
    hidden: "hidden",
    visible: "visible",
  } as const satisfies Record<VisibilityPhase, VisibilityPhase>;

  const render = {
    [phaseKeys.hidden]: <EmptyView />,
    [phaseKeys.visible]: <PasswordResetLogoView logoUri={logoUri} />,
  } as const satisfies Record<VisibilityPhase, React.ReactElement>;

  return render[phase as keyof typeof render];
};

export default React.memo(PasswordResetLogoPanel, (prevProps, nextProps) => {
  return prevProps.phase === nextProps.phase && prevProps.logoUri === nextProps.logoUri;
});
